/**
 * 성향(traits) — 개체 생성 시 1회 굴려 고정. 판단 점수의 가중치로만 쓰인다.
 * 성향이 행동을 직접 고르지 않는다: 후보 행동의 점수를 기울일 뿐 (지시서 3.3).
 */
import type { Traits } from '@villager/shared';
import type { Rng } from './rng.js';

export function rollTraits(rng: Rng): Traits {
  return {
    caution: rng.next(),
    greed: rng.next(),
    loyalty: rng.next(),
    glory: rng.next(),
  };
}

/** 멤버들의 특정 성향 평균 (파티 단위 판정에 사용). */
export function avgTrait(members: readonly { traits: Traits }[], key: keyof Traits): number {
  if (!members.length) return 0.5;
  let s = 0;
  for (const m of members) s += m.traits[key];
  return s / members.length;
}
